import imgHoangSaIslands from 'assets/images/EVG/HoangSa.png';
import imgTruongSaIslands from 'assets/images/EVG/TruongSa.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import Utils from 'general/utils/Utils';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { ImageOverlay, MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';

const HOANG_SA_BOUNDS = [
  [17.0, 111.5],
  [18.0, 112.5],
];
const TRUONG_SA_BOUNDS = [
  [11.0, 113.5],
  [12.0, 114.5],
];

const iconCache = {};
function getPinIcon(iconUrl) {
  if (!iconCache[iconUrl]) {
    iconCache[iconUrl] = L.icon({
      iconUrl,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
    });
  }
  return iconCache[iconUrl];
}

// Cập nhật center bản đồ khi danh sách trạm thay đổi lần đầu
function MapController({ stationList }) {
  const map = useMap();
  const initialized = useRef(false);
  useEffect(() => {
    if (stationList?.length > 0 && !initialized.current) {
      initialized.current = true;
      const lat = stationList[0]?.latitude || 14.0583;
      const lng = stationList[0]?.longitude || 105.2772;
      map.setView([lat, lng], map.getZoom());
    }
  }, [stationList]);
  return null;
}

SOCStationMapView.propTypes = {
  stationList: PropTypes.array,
};

function SOCStationMapView({ stationList = [] }) {
  return (
    <>
      {/* Chỉ áp filter lên tile layer, không áp lên marker */}
      <style>{`
        .soc-map-container .leaflet-tile-pane {
          filter: invert(1) grayscale(1) brightness(0.85) contrast(0.9);
        }
      `}</style>
      <MapContainer
        className="soc-map-container"
        center={[14.0583, 105.2772]}
        zoom={6}
        style={{ width: '100%', height: '100%' }}
        zoomControl={false}
        attributionControl={false}
      >
        {/* OSM Mapnik — ưu tiên tag name (tiếng Việt), không dùng name:en */}
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <ImageOverlay url={imgHoangSaIslands} bounds={HOANG_SA_BOUNDS} />
        <ImageOverlay url={imgTruongSaIslands} bounds={TRUONG_SA_BOUNDS} />
        <MapController stationList={stationList} />
        {stationList.map((station) => {
          if (!Utils.isValid(station.latitude) || !Utils.isValid(station.longitude)) return null;
          return (
            <Marker
              key={station.stationId}
              position={[station.latitude, station.longitude]}
              icon={getPinIcon(ChargeHelper.Utils.getChargeStationPinIcon(station.status))}
            />
          );
        })}
      </MapContainer>
    </>
  );
}

export default SOCStationMapView;
